import { FC } from "react";
import { Box, Card, Stack } from "@mui/material";
import { useFlag } from "@unleash/proxy-client-react";
import { DashboardDimensionAndCategoryFilters } from "@/components/pages/dashboard/components/filters/dimension-category-filters/DashboardDimensionAndCategoryFilters";
import { DashboardDates } from "@/components/pages/dashboard/components/filters/DashboardDates";
import { HomeDashboardSelect } from "@/components/pages/dashboard/home-page/HomeDashboardSelect";

interface DashboardFiltersProps {
  dashboardId: string;
  showDashboardSelect?: boolean;
}

export const DashboardFilters: FC<DashboardFiltersProps> = ({
  dashboardId,
  showDashboardSelect,
}) => {
  const enableDashboardDateAndCategoryFilter = useFlag(
    "EnableDashboardDateAndCategoryFilter",
  );

  if (!enableDashboardDateAndCategoryFilter) {
    return null;
  }

  return (
    <Box p={1} pb={0}>
      <Card variant="outlined">
        <Stack
          direction="row"
          py={0.5}
          px={1.5}
          spacing={1}
          alignItems="center"
        >
          {showDashboardSelect && <HomeDashboardSelect />}

          <Box py={1}>
            <DashboardDates dashboardId={dashboardId} />
          </Box>

          <DashboardDimensionAndCategoryFilters dashboardId={dashboardId} />
        </Stack>
      </Card>
    </Box>
  );
};
